var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"rd-cols"},[(_vm.items.length >= _vm.MIN_ITEMS)?_c('report-checklist-menu',{attrs:{"label":_vm.$t('visible_columns'),"items":_vm.items,"value":_vm.visibleValues},on:{"input":_vm.setVisible}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }